import { combineReducers } from 'redux';

import byId from './byId/reducer';
import byQuery from './byQuery/reducer';
import paging from './paging/reducer';
import textEditing from './textEditing/reducer';
import emojis from './emojis/reducer';
import sort from './sort/reducer';
import live from './live/reducer';

export default combineReducers({
  byId,
  byQuery,
  paging,
  textEditing,
  emojis,
  sort,
  live
});



/** WEBPACK FOOTER **
 ** ./src/members/state/comments/reducer.js
 **/